import { useAuthStore } from 'processes/auth/model/state';
import { ECoUserPermission } from 'permissions';

export function usePermissions() {
	const { permissions, isAdmin, isUser } = useAuthStore();

	const isOwner = isUser || isAdmin;

	const hasPermission = (permission: ECoUserPermission): boolean => {
		if (isOwner) return true;
		return permissions?.includes(permission) ?? false;
	};

	return {
		isOwner,
		hasPermission,
		canReadCoUsers: hasPermission(ECoUserPermission.CO_USERS_READ),
		canWriteCoUsers: hasPermission(ECoUserPermission.CO_USERS_WRITE),
		canDeleteCoUsers: hasPermission(ECoUserPermission.CO_USERS_DELETE),
	};
}
